module.exports = __webpack_public_path__ + "img/xianjin@2x.3b68c454.png";